import get from 'lodash/get';
import { generateUUID } from '../generateUUID';

export const getSessionCorrelation = (sessionId, append = '') => ({
  'x-hsbc-session-correlation-id': `${sessionId + append}` || `STUB_ALL`, // TODO remove STUB_ALL once fix available,
});

export const getSessionCorrelationFromReq = (req = {}) => {
  const sessionId =
    get(req, 'headers[x-hsbc-session-correlation-id]') ||
    get(req, 'cookies.sessionId') ||
    generateUUID();

  const stub = get(req, 'query.stub') ? `,stub=${get(req, 'query.stub')}` : '';

  return getSessionCorrelation(sessionId, stub);
};
